import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CancelButtonLink from '../../../../../common/buttons/cancelButtonLink';
import { getUserUrlPrefix } from '../../../../../auth/selectors';
import { t } from '../../../../../../modules/infra/i18n';

const withLink = connect(state => ({
  link: `${getUserUrlPrefix(state)}/barbers`,
}));

const CancelButton = ({ link, resetBarber }) => (
  <CancelButtonLink
    link={link}
    onClick={resetBarber}
    content={t('barber:brand_barber.cancel.button')}
  />
);

CancelButton.propTypes = {
  link: PropTypes.string.isRequired,
  resetBarber: PropTypes.func.isRequired,
};

export default withLink(CancelButton);
